<template>
	<div
		ref="buildingTag"
		class="building-tag"
		:class="{
			active: isCategoryEnabled(category),
			disabled: isCategoryDisabled(category)
		}"
		:style="{ left: coordsX + 'px', top: coordsY + 'px' }"
	>
		<svgicon :name="`expenseCategories/${category.assetName}`"></svgicon>
		<span>{{ category.name }}</span>

		<div v-if="isCategoryDisabled(category)" class="status-tag disabled">
			<svgicon name="lock"></svgicon>
		</div>
		<div
			v-else-if="
				category.isCompletedForCurrentStudent || isCategoryBudgeted(category)
			"
			class="status-tag completed"
		>
			<svgicon name="check"></svgicon>
		</div>
		<div class="tag-pointer"></div>
	</div>
</template>
<script>
import '../icons/check';
import '../icons/lock';
import '../icons/expenseCategories';
import CategoryCheck from '@/mixins/CategoryCheck';

export default {
	mixins: [CategoryCheck],
	props: {
		coords: {
			type: Object,
			default: () => {
				return {};
			}
		},
		category: {
			type: Object,
			default: null
		},
		coordsX: {
			type: Number,
			default: 0
		},
		coordsY: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
};
</script>
<style lang="scss" scoped>
.building-tag {
	position: absolute;
	border-radius: 21px;
	padding: 8px 16px;
	color: #ffffff;
	display: flex;
	align-items: center;
	margin-top: -35px;
	background-color: $primary-state;
	transform: translate(-50%, -10px);
	margin-right: -50%;

	* {
		flex-shrink: 0;
	}

	&.disabled {
		background-color: #687682;

		.tag-pointer {
			background-color: #687682;
		}
	}

	&.active {
		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				background-color: $hover-state;

				.tag-pointer {
					background-color: $hover-state;
				}
			}
		}

		&:active {
			background-color: $tapped-state;

			.tag-pointer {
				background-color: $tapped-state;
			}
		}
	}

	svg {
		fill: #ffffff;
		margin-right: 8px;
	}

	.tag-pointer {
		width: 16px;
		height: 16px;
		transform: rotate(45deg);
		position: absolute;
		background-color: $primary-state;
		left: 0;
		right: 0;
		bottom: -8px;
		margin: auto;
	}

	.status-tag {
		position: absolute;
		top: -6px;
		right: -6px;
		height: 24px;
		width: 24px;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		&.completed {
			background-color: $building-tag-status-tag-completed;
		}

		&.disabled {
			background-color: #363e52;
		}

		svg {
			height: 12px;
			width: 12px;
			fill: #ffffff;
			margin: 0;
		}
	}
}
</style>
